/* eslint-disable */
import React, { Component } from "react";
import B4FInput from "../B4FInputBB/B4FInput";
import { Box, HStack, Circle, Heading, Grid, GridItem } from "@chakra-ui/react";
import { withTranslation, Trans } from "react-i18next";
import { Checkbox } from "@material-ui/core";

class FieldsContainer extends Component<any> {
  getVal = (fieldName: string) => {
    return document.getElementById(fieldName);
  };

  render() {
    const { t, i18n } = this.props;

    return (
      <Box py={15} id={this.props.id}>
        <Box bg="brand.bgDisabled" p={5} borderRadius="20px" pb={16}>
          <HStack>
            {this.props.config && <Checkbox aria-label="visibility" />}
            <Circle
              fontSize="11px"
              color="brand.bf4"
              borderRadius="20px"
              borderColor="brand.bf3"
              borderWidth="2px"
              width="20px"
              mb={4}
            >
              {this.props.index}
            </Circle>
            <Heading
              fontSize="16px"
              color="brand.bf3"
              fontWeight="normal"
              fontFamily="ABeeZee"
              mb={5}
            >
              <Trans>{t(`distributor:${this.props.data.label}`)}</Trans>
            </Heading>
          </HStack>

          <Grid templateColumns="repeat(2,1fr)" gap={4}>
            {this.props.data.questions.map((field: any) => {
              return (
                (field.visibleOperator ||
                  field.visibleDistributor ||
                  field.visibleInvestor) && (
                  <GridItem colSpan={4} key={field.id + "-field_Container"}>
                    <B4FInput
                      id={field.key}
                      label={field.label}
                      type={field.type}
                      options={this.props.enums[field.optionEnum]}
                      placeholder={field.label}
                      name={field.label}
                      value={""}
                      onChange={console.log}
                      onBlur={console.log}
                      isInvalid
                      isDisabled={true}
                      visible={true}
                    />
                  </GridItem>
                )
              );
            })}
          </Grid>
        </Box>
      </Box>
    );
  }
}

export default withTranslation()(FieldsContainer);
